/* eslint-disable import/prefer-default-export */
/* eslint-disable max-len */
import { toastr } from 'react-redux-toastr';
import {
    pendingTask,
    begin,
    end,
} from 'react-redux-spinner';
import { LOADING_END, LOADING_START } from '../loading';
import * as apiManager from '../../Manager/services/api-endpoints';
import FileService from '../../services/FileService';
import { ExportActions } from '../../Enums';
import i18n from '../../services/i18n';

/**
 * @param {string[]} profileIds
 * @param {ExportActions} exportAction
 */
export const downloadReportAsExcel = (profileIds, exportAction) => /** @param {import('redux').Dispatch} dispatch */async (dispatch) => {
    try {
        dispatch({ type: LOADING_START, [pendingTask]: begin });
        const [profileId] = profileIds;
        if (exportAction === ExportActions.ExportManager) {
            const response = await apiManager.DownloadManagerAuditReport(profileId);
            if (response.status === 200) {
                FileService.downloadContentInFile('ManagerAuditReport', 'xlsx', response.data);
            } else {
                toastr.error(i18n.t('shiftBidding:toastr.downloadingManagerAuditReport'), i18n.t('shiftBidding:toastr.failedToDownload'));
            }
        } else {
            const response = await apiManager.DownloadEmployeeAuditReport(profileId);
            if (response.status === 200) {
                FileService.downloadContentInFile('EmployeeAuditReport', 'xlsx', response.data);
            } else {
                toastr.error(i18n.t('shiftBidding:toastr.downloadingEmployeeAuditReport'), i18n.t('shiftBidding:toastr.failedToDownload'));
            }
        }
    } catch (error) {
        toastr.error(i18n.t('shiftBidding:toastr.downloadingAuditReport'), i18n.t('shiftBidding:toastr.failedToDownload'));
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
